export const BILLING_SOCIETY_OPTIONS = [
  "Balanz Capital Valores",
  "Balanz Sociedad Gerente",
  "Dólar Balanz",
  "Balanz Capital",
  "Sin definir",
];

export const CERTIFICATES_CONFIG = [
  {
    label: "IIGG Exento",
    name: "iigg_exento",
    fileKey: "iigg_exento_file",
    documentType: "doc_iigg",
  },
  {
    label: "Exención Santa Fe",
    name: "sf_exento",
    fileKey: "sf_exento_file",
    documentType: "doc_exencion_santafe",
  },
  {
    label: "Exención Buenos Aires",
    name: "bsas_exento",
    fileKey: "bsas_exento_file",
    documentType: "doc_exencion_bsas",
  },
  {
    label: "Exención CABA",
    name: "caba_exento",
    fileKey: "caba_exento_file",
    documentType: "doc_exencion_caba",
  },
  {
    label: "IIBB Categoría",
    name: "iibb_category",
    fileKey: "iibb_category_file",
    documentType: "doc_iibb_categoria",
  },
];

export const IIBB_JURISDICCION_MODE = {
  MULTIPLE: "multiple",
  SINGLE: "single",
  LOCKED_TO_DOMICILE: "locked_to_domicile",
};

export const getIibbJurisdiccionMode = (iibbCategory) => {
  const category = Number(iibbCategory);

  if (category === 1) return IIBB_JURISDICCION_MODE.MULTIPLE;
  if (category === 2) return IIBB_JURISDICCION_MODE.SINGLE;
  if (category === 3) return IIBB_JURISDICCION_MODE.MULTIPLE;
  if (category === 4) return IIBB_JURISDICCION_MODE.LOCKED_TO_DOMICILE;
  if (category === 5) return IIBB_JURISDICCION_MODE.SINGLE; 

  return IIBB_JURISDICCION_MODE.MULTIPLE;
};